"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _excluded = ["title", "titleId"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var SvgText = function SvgText(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#1EA7FD",
    d: "m9.816 27.54 3.818-10.892h.773l3.695 10.892H9.816Zm6.919-.98-2.724-8.028-2.814 8.029h5.538Zm-5.328-15.59L1.685 37.002h4.85l2.092-6.016h10.675l2.018 6.016h5.034l-9.613-26.034h-5.334ZM9.323 31.966l-2.092 6.015H.274L10.727 9.99h6.696L27.76 37.982h-7.145l-2.017-6.015H9.323Zm19.801-8.509h4.34c.164-.963.554-1.694 1.18-2.17.692-.525 1.617-.78 2.762-.78.498 0 .964.033 1.4.1.474.072.896.22 1.264.444.386.234.695.563.923.977.23.422.34.96.34 1.595.031.7-.188 1.271-.662 1.666-.41.34-.949.592-1.613.76-.623.158-1.332.275-2.127.353-.762.075-1.537.174-2.325.3-.78.122-1.553.289-2.32.499-.731.2-1.377.497-1.94.893-.546.383-.993.899-1.344 1.552-.344.641-.52 1.477-.52 2.511 0 .942.154 1.743.459 2.406a4.433 4.433 0 0 0 1.262 1.639c.546.437 1.185.76 1.92.97a8.889 8.889 0 0 0 2.444.322c1.146 0 2.268-.17 3.367-.508a6.41 6.41 0 0 0 2.78-1.725l.759-.791.083 1.093a7.678 7.678 0 0 0 .249 1.439h4.268c-.115-.36-.201-.782-.261-1.266a21.183 21.183 0 0 1-.153-2.595V22.965c0-1.089-.234-1.94-.691-2.569a4.9 4.9 0 0 0-1.837-1.532 8.456 8.456 0 0 0-2.58-.768 20.893 20.893 0 0 0-2.883-.203c-1.039 0-2.07.104-3.097.312a8.558 8.558 0 0 0-2.705 1.019 5.905 5.905 0 0 0-1.934 1.853c-.422.642-.693 1.434-.808 2.381Zm9.099 14.465a12.348 12.348 0 0 1-3.656.551c-.966 0-1.87-.12-2.712-.359a6.364 6.364 0 0 1-2.265-1.148 5.412 5.412 0 0 1-1.54-1.994c-.367-.8-.548-1.739-.548-2.815 0-1.185.21-2.178.637-2.975.421-.784.97-1.416 1.644-1.89a7.145 7.145 0 0 1 2.245-1.036c.802-.22 1.61-.394 2.425-.522.806-.128 1.6-.23 2.382-.307.75-.073 1.41-.183 1.983-.328.531-.134.939-.324 1.226-.564.224-.185.328-.459.31-.89 0-.505-.078-.886-.22-1.146a1.587 1.587 0 0 0-.572-.611 2.429 2.429 0 0 0-.904-.313 8.27 8.27 0 0 0-1.252-.089c-.947 0-1.665.199-2.17.581-.476.362-.766.993-.854 1.926l-.042.444h-6.27l.03-.519c.08-1.342.416-2.471 1.014-3.38a6.884 6.884 0 0 1 2.25-2.157 9.535 9.535 0 0 1 3.012-1.137c1.09-.221 2.188-.332 3.292-.332.994 0 2 .071 3.019.213a9.433 9.433 0 0 1 2.875.859 5.879 5.879 0 0 1 2.198 1.835c.59.81.878 1.862.878 3.145v10.177c0 .863.049 1.688.146 2.475.092.743.248 1.285.454 1.618l.461.747h-6.612l-.111-.336a8.277 8.277 0 0 1-.27-1.047 7.327 7.327 0 0 1-2.483 1.324Zm2.293-10.366.817-.736v3.105c0 .326-.032.748-.097 1.27a4.576 4.576 0 0 1-.562 1.673c-.317.57-.8 1.051-1.442 1.446-.66.408-1.556.603-2.685.603-.454 0-.895-.04-1.324-.122a3.46 3.46 0 0 1-1.217-.465 2.51 2.51 0 0 1-.88-.96c-.215-.403-.32-.885-.32-1.44 0-.58.104-1.073.32-1.478a2.91 2.91 0 0 1 .83-.976 3.95 3.95 0 0 1 1.15-.584 9.988 9.988 0 0 1 1.243-.32c.432-.077.865-.141 1.298-.193.412-.049.804-.11 1.178-.183.366-.072.706-.16 1.021-.267.276-.093.497-.218.67-.373Zm-.357 1.3c-.357.121-.739.221-1.145.301-.399.078-.816.143-1.251.195-.414.05-.828.111-1.237.184-.378.072-.75.167-1.116.287-.337.11-.625.256-.867.437a1.93 1.93 0 0 0-.552.652c-.134.25-.205.589-.205 1.018 0 .404.07.729.205.98.134.255.313.45.539.593.245.154.535.265.875.33.368.07.749.104 1.142.104.963 0 1.686-.157 2.171-.456.505-.311.869-.674 1.1-1.09a3.6 3.6 0 0 0 .446-1.315c.06-.487.09-.871.09-1.151v-1.14c-.063.025-.128.05-.195.072Z"
  }));
};

var _default = SvgText;
exports["default"] = _default;